export default "__VITE_ASSET__BQlnyzWN__"